module.exports = __webpack_public_path__ + "static/media/DIGITAL_EVENT_SMALL.a5293dac.jpg";